import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-wavy-circle-2",
  "use": "foquz-icon-wavy-circle-2-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-wavy-circle-2\"><circle cx=\"8\" cy=\"8\" r=\"8\" fill=\"#ECEFF1\" /><path d=\"M5.051 8.497c.34-.37 1.596-1.104 2.984-.307 1.39.798 2.646.062 2.985-.307\" stroke=\"#000\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol